
<div class="containers">
    <h2 class="sub_title">Payment methods</h2>
    <input type="checkbox" id="paymentMethodCheckbox" checked class="checkbox">
    <label for="paymentMethodCheckbox" >Enable payment methods</label>
</div>
<!-- <div class="form-header">
    <h2 class="sub_title">Payment methods</h2>
  </div> -->


<div class="um-container" style="margin-bottom: 10px">
    <div class="ud-form-group">
        <label for="form-group--1" class="ud-form-label ud-heading-sm" >
            Your saved payment methods
        </label>
        <div class="edit-account-form--form-control-container--1NHES">
            <div class="edit-account-form--fake-input--1C1DY">
                <span></span>
                <p>You don’t have any saved payment method</p>
            </div>
        </div>
    </div>
</div>